export enum StatusType {
  SUCCESS,
  ERROR,
}

export interface IStatus {
  code: number;
  message: string;
  key: string;
  type: StatusType;
}

export interface DataResponse<T> {
  status: IStatus;
  data: T;
}

export interface ListResponse<T> {
  status: IStatus;
  data: T[];
}

export enum CurrencyCode {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  AUD = 'AUD',
  CAD = 'CAD',
  CHF = 'CHF',
  CNY = 'CNY',
  SEK = 'SEK',
  NZD = 'NZD',
  INR = 'INR',
  RUB = 'RUB',
  BRL = 'BRL',
  ZAR = 'ZAR',
  MXN = 'MXN',
  SGD = 'SGD',
  HKD = 'HKD',
  KRW = 'KRW',
  TRY = 'TRY',
  NOK = 'NOK',
  DKK = 'DKK',
  PLN = 'PLN',
  THB = 'THB',
  MYR = 'MYR',
  IDR = 'IDR',
  PHP = 'PHP',
  VND = 'VND',
  SAR = 'SAR',
  AED = 'AED',
  ILS = 'ILS',
  EGP = 'EGP',
}

export interface CurrencyInfo {
  code: CurrencyCode;
  fullName: string;
}
